/* eslint-disable jsx-a11y/anchor-is-valid */
import { SettingsInputComponentSharp } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Link } from "react-router-dom";
import { getFromLocalStorage } from "../../../../../app/utils/storage";
import * as actionsMenu from "../../aside/menuAction.js";
import * as actionsContents from "../../../../../app/modules/KnowledgeBase/_redux/contents/contentsActions.js";

export function BreadCrumbs({ items }) {
  const currentKnowledge = useSelector((state) => state.views.currentKnowledge);
  const dispatch = useDispatch();

  const { menu, contents } = useSelector(
    (state) => ({
      menu: state.menu,
      contents: state.contents,
    }),
    shallowEqual
  );

  const [_paths, setPaths] = useState(items);

  const getMenuItensByProduct = () => {
    let type = currentKnowledge?.knowledge_type_id; // faq | video ...
    if (currentKnowledge?.products.length > 0) {
      switch (type) {
        case 1:
          currentKnowledge?.products.forEach((element) => {
            if ((menu.faqs[element.id] ?? []).length > 0) return;

            dispatch(
              actionsMenu.fetchFaqsMenu({
                filter: {
                  products: [element.id],
                  module: [currentKnowledge.sub_products?.id],
                },
              })
            );
          });

          dispatch(
            actionsMenu.setFaqOpenedProductMenu(
              currentKnowledge?.products.map((p) => p.id),
              currentKnowledge.sub_products?.id
            )
          );

          break;
        case 2:
          currentKnowledge?.products.forEach((element) => {
            if ((menu.videos[element.id] ?? []).length > 0) return;

            dispatch(
              actionsMenu.fetchVideosMenu({
                filter: {
                  products: [element.id],
                  module: [currentKnowledge.sub_products?.id],
                },
              })
            );
          });

          dispatch(
            actionsMenu.setVideosOpenedProductMenu(
              currentKnowledge?.products.map((p) => p.id),
              currentKnowledge.sub_products?.id
            )
          );

          break;
        case 3:
          currentKnowledge?.products.forEach((element) => {
            if ((menu.manuals[element.id] ?? []).length > 0) return;

            dispatch(
              actionsMenu.fetchManualsMenu({
                filter: {
                  products: [element.id],
                  module: [currentKnowledge.sub_products?.id],
                },
              })
            );
          });

          dispatch(
            actionsMenu.setManualsOpenedProductMenu(
              currentKnowledge?.products.map((p) => p.id) ?? [],
              currentKnowledge.sub_products?.id ?? []
            )
          );

          break;
        case 4:
          currentKnowledge?.products.forEach((element) => {
            if ((menu.updates[element.id] ?? []).length > 0) return;

            dispatch(
              actionsMenu.fetchUpdatesMenu({
                filter: {
                  products: [element.id],
                  module: [currentKnowledge.sub_products?.id],
                },
              })
            );
          });

          dispatch(
            actionsMenu.setUpdatesOpenedProductMenu(
              currentKnowledge?.products.map((p) => p.id) ?? [],
              currentKnowledge.sub_products?.id ?? []
            )
          );

          break;
        case 5:
          currentKnowledge?.products.forEach((element) => {
            if ((menu.links[element.id] ?? []).length > 0) return;

            dispatch(
              actionsMenu.fetchLinksMenu({
                filter: {
                  products: [element.id],
                  module: [currentKnowledge.sub_products?.id],
                },
              })
            );
          });

          dispatch(
            actionsMenu.setLinksOpenedProductMenu(
              currentKnowledge?.products.map((p) => p.id) ?? [],
              currentKnowledge.sub_products?.id ?? []
            )
          );

          break;
        case 6:
          currentKnowledge?.products.forEach((element) => {
            if ((menu.newsletters[element.id] ?? []).length > 0) return;

            dispatch(
              actionsMenu.fetchNewsletterMenu({
                filter: {
                  products: [element.id],
                  module: [currentKnowledge.sub_products?.id],
                },
              })
            );
          });

          dispatch(
            actionsMenu.setNewslettersOpenedProductMenu(
              currentKnowledge?.products.map((p) => p.id) ?? [],
              currentKnowledge.sub_products?.id ?? []
            )
          );

          break;
        default:
          break;
      }
    }
  };

  const mountPathOrigin = (path) => {
    let paths = items;
    if (items.length >= 3 && currentKnowledge?.products?.length > 0) {
      currentKnowledge?.products.forEach((item) => {
        return (
          paths.splice(1 + 1, 0, {
            pathname: `/knowledge-base/${path}/productId:${item.id}`,
            title: item.name,
            knowledgeTypeId: currentKnowledge?.knowledge_type_id
          })
        );
      }
      );
      if (currentKnowledge?.sub_products) {
        let currentProduct = currentKnowledge.products.find(
          (item) => item.id === currentKnowledge.sub_products.system_product_id
        );
        paths.splice(1 + 2, 0, {
          pathname: `/knowledge-base/${path}/productId:${currentProduct.id}subProductId:${currentKnowledge.sub_products.id}`,
          title: currentKnowledge.sub_products.name,
          knowledgeTypeId: currentKnowledge?.knowledge_type_id
        });
      }
      console.log("paths", paths);
      setPaths(paths);
    } else {
      setPaths(items);
    }
  };

  let currentMenu = getFromLocalStorage("currentMenu");
  useEffect(() => {
    getMenuItensByProduct();
    mountPathOrigin(currentMenu);
  }, [items, currentKnowledge?.products, currentMenu]);

  useEffect(() => {
    if (contents.products.length === 0) {
      dispatch(actionsContents.fetchProducts());
    }
  }, [])

  if (!items || !items.length) {
    return "";
  }

  return (
    <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
      <li className="breadcrumb-item">
        <Link to="/home">
          <i className="flaticon2-shelter text-muted icon-1x" />
        </Link>
      </li>
      {_paths.map((item, index) => {
        const IS_FIRST = index == 0;
        if (!IS_FIRST) {
          let lastPath = _paths[index - 1];
          let currentPath = item;

          if (lastPath?.title == currentPath?.title) return;
        }

        return (
          <li key={`bc${index}`} className="breadcrumb-item">
            <Link
              onClick={() => {
                if (currentKnowledge?.products.length > 0) {
                  let knowledgeTypeId = item?.knowledgeTypeId;
                  let productId = item?.pathname.split('productId:')[1];
                  let subProductId = item?.pathname.split('subProductId:')[1];
                  setCurrentMenuWhenNavigateByBreadCrumbs(parseInt(knowledgeTypeId), parseInt(productId), parseInt(subProductId))
                }
              }}
              className="text-muted"
              to={{ pathname: item?.pathname }}
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                display: "inline-block",
                margin: "auto",
                maxWidth: 500,
              }}
            >
              {item?.title}
            </Link>
          </li>
        );
      })}
    </ul>
  );

  function setCurrentMenuWhenNavigateByBreadCrumbs(knowledgeTypeId, productId, moduleId) {
    if (currentKnowledge?.products.length > 0) {
      switch (knowledgeTypeId) {
        case 1:
          dispatch(
            actionsMenu.setFaqOpenedProductMenu([productId], [moduleId])
          );

          break;
        case 2:
          dispatch(
            actionsMenu.setVideosOpenedProductMenu([productId], [moduleId])
          );

          break;
        case 3:
          dispatch(
            actionsMenu.setManualsOpenedProductMenu([productId])
          );

          break;
        case 4:
          dispatch(
            actionsMenu.setUpdatesOpenedProductMenu([productId])
          );

          break;
        case 5:
          dispatch(
            actionsMenu.setLinksOpenedProductMenu([productId])
          );

          break;
        case 6:
          dispatch(
            actionsMenu.setNewslettersOpenedProductMenu([productId])
          );

          break;
        default:
          dispatch(actionsMenu.setManualsOpenedProductMenu([], []));
          dispatch(actionsMenu.setUpdatesOpenedProductMenu([], []));
          dispatch(actionsMenu.setLinksOpenedProductMenu([], []));
          dispatch(actionsMenu.setNewslettersOpenedProductMenu([], []));
          break;
      }
    }
  }
}